import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BoxComponent } from './box/box.component';

@NgModule({
  imports: [CommonModule],
  exports: [BoxComponent],
  declarations: [BoxComponent],
})
export class BoxModule {}
